import { styled, Link, Typography } from '@ori-ui/mui';

import { maxTextWidth } from '../../constants';

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'inline-block',
  textDecoration: 'underline',
}));

export const Inner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(1),
  },
}));

export const Links = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4),
}));

export const CopyrightTitle = styled(Typography)(() => ({
  maxWidth: maxTextWidth,
}));
